import { render, staticRenderFns } from "./ModalFaqConfigListagem.vue?vue&type=template&id=11c19e74&"
import script from "./ModalFaqConfigListagem.vue?vue&type=script&lang=js&"
export * from "./ModalFaqConfigListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports